<template>
  <div>
    <div class="class-intro-box" id="box7">
      <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/class_intro_title.png" alt="" />
      <div class="intro-content w1200">
        <div class="sticky-box">
          <div class="title-content">
            <div class="title-box" :class="courseIndex == index ? 'on' : ''" v-for="(item, index) in courseList" :key="item.id" @click="courseIndex = index">
              {{ item.className }}
            </div>
          </div>
        </div>
        <div class="label-box">
          <span style="margin-right: 180px">课程名称</span>
          <span style="margin-right: 200px">价格</span>
          <span style="margin-right: 280px">包含班级</span>
          <span>提供服务</span>
        </div>
        <div class="detail-container">
          <div class="left-box">
            <div class="content-box" v-for="(item, index) in courseList[courseIndex].list" :key="index">
              <template v-if="item.isOnLineService">
                <div class="course-name" style="cursor: default;" >
                {{ item.courseName }}
              </div>
              <div class="money-box" style="color:#2d67e3;font-size: 16px;" @click="serviceClick">{{ item.money }}</div>
              </template>
              <template v-else>
                <div class="course-name" @click="itemClick(item)">
                    <img v-if="item.isChecked" src="@/assets/publicity1/check-box-selected.png" alt="" />
                    <img v-else src="@/assets/publicity1/check-box.png" />
                {{ item.courseName }}
              </div>
              <div class="money-box">￥{{ item.money }}</div>
              </template>

            </div>
          </div>

          <div class="right-box">
            <div class="course-box">
              <div class="kcnr" v-for="(item, index) in courseList[courseIndex].classContent" :key="index">
                <div class="title-des" :style="{ 'padding-left': item.children ? '0px' : '25px' }">
                  <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/minus_icon.png" v-if="item.children" />{{ item.title }}
                </div>
                <div class="children" v-for="child in item.children">
                  <span v-html="child"></span>
                </div>
              </div>
            </div>
            <div class="class-service-box">
              <span>APP服务：</span>
              <ul>
                <li v-for="v in courseList[courseIndex].information">
                  <img src="@/assets/publicity1/right_icon.png" alt="" />
                  {{ v }}
                </li>
              </ul>
              <span>人工服务：</span>
              <ul>
                <li v-for="j in courseList[courseIndex].service">
                  <img src="@/assets/publicity1/right_icon.png" alt="" />
                  {{ j }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="buy-box">
          <p v-if="">
            应付金额：<template v-if="moneyLabels && moneyLabels.indexOf('+') !=-1">{{ moneyLabels }} &nbsp;&nbsp;=&nbsp;&nbsp;</span>&nbsp;&nbsp;</template> <span>￥{{ totalMoney }} </span><span class="buy" @click="$emit('spon', { ref: 'lff', fn: 'box3OpenOpen' })">立即购买</span>
          </p>
        </div>
      </div>
    </div>
    <div class="teacher-box" id="box8">
      <div class="w1200 t-box">
        <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/teacher_title_box.png" alt="" />
        <ul class="nav">
          <li :class="teamIndex == index ? 'on' : ''" v-for="(item, index) in teamList" @click="teamNavClick(index)">{{ item }}</li>
        </ul>
        <div class="content">
          <template v-for="(sub, index) in teacherList[teamIndex].filter(item => item.isFirst)">
            <img class="cover" :src="sub.cover" alt="" />
          </template>
          <div class="r-info">
            <template v-for="(sub, index) in teacherList[teamIndex].filter(item => item.isFirst)">
              <template>
                <h3>{{ sub.name }}</h3>
                <span>主讲：{{ sub.zj }}</span>
                <ul>
                  <li v-for="v in sub.des">- {{ v }}</li>
                </ul>
              </template>
            </template>
            <div class="more-cover">
              <template v-for="(other, j) in teacherList[teamIndex]">
                <img :src="other.cover" :class="j == currentIndexTeacher ? 'on' : ''" alt="" @click="changeClick(j, other)" />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="service-box" id="box9">
      <div class="w1200">
        <div class="title-img-box">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/1v1_service.png" alt="" />
        </div>
        <ul>
          <li>
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/1v1_01.png" alt="" />
          </li>
          <li>
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/1v1_02.png" alt="" />
          </li>
          <li>
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/1v1_03.png" alt="" />
          </li>
          <li>
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/1v1_04.png" alt="" />
          </li>
        </ul>
      </div>
    </div>
    <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/bottom_bg.png" class="bottom-bg" alt="" />
  </div>
</template>
<script>
import { loadScript } from '@/utils/index'
export default {
  data() {
    return {
      teamIndex: 0,
      teamList: ['政治', '英语一', '英语二', '数学', '管理类联考', '教育综合', '护理综合', '西医综合', '应用心理', '法律'],
      currentIndexTeacher: 0,
      teacherList: [
        [

          {
            name: '米鹏',
            zj: '考研政治',
            des: [
              '全国著名考研政治辅导专家，考研行业资深辅导名师',
              '考研政治辅导领域讲课和押题双料冠军，在考研政治辅导领域耕耘18年，培训学员超300万人，融会贯通考研政治五科内容，讲课诙谐幽默、重点突出，尤擅考前预测，因多年保持超高的考题命中率，在广大考生中享有“考政治，找米神”的美誉。'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/米鹏.png',
            isFirst: true
          },
          {
            name: '牛子儒',
            zj: '考研政治',
            des: [
              '考研辅导少壮派代表，教育部高等教育出版社考研思想政治知识点系列图书主编，深受历届考研学子爱戴。',
              '条理清晰，效果显著，幽默风趣，重点鲜明；立足宏观，研究命题规律，把握出题方向注重对知识点进行去粗取精，突出重点，详解难点，归纳、总结跨学科考点。使考生能够实现“扎实掌握基本理论知识”“全面提高文科素质”“灵活运用解答技巧”“精确把握命题脉搏”四者的有机统一，培养学生分析问题、归纳问题、总结问题的能力，轻松自如地应对考试。'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/牛子儒.png',
            isFirst: false
          }
        ],
        [
          {
            name: '王天石',
            zj: '考研英语',
            des: [
              '北京师范大学硕士，剑桥商务英语高级，十年考研英语授课经验；',
              '著名实力派考研英语辅导专家。长期从事考研英语辅导工作，熟知考研出题特点。',
              '授课风趣幽默，课堂气氛活跃，深入浅出，化繁为简，独创的阅读技巧帮助学生了解出题意图，快速找到解题思路，让学生真正的了解考试，深得学生喜爱。'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/王天石.png',
            isFirst: true
          },
          {
            name: '吕坤',
            zj: '考研英语',
            des: [
              '多年考研英语授课经验，深谙命题规律和解题技巧，深入浅出，化难为易',
              '对英语语言的学习有自己独到的见解。课堂气氛活跃，充实紧凑，学生能在短时间内提高英语成绩。'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/吕坤.png',
            isFirst: false
          },
          {
            name: '王素丽',
            zj: '考研英语',
            des: [
              '西安外国语大学硕士，十余年考研英语辅导经验。资深考研英语辅导老师，多年考研英语教学经验。',
              '专业扎实，治学严谨，授课幽默风趣；对考研英语命题特点及答题方法技巧的研究深入透彻， 尤其擅长耐心高效地帮助基础较差的学生迅速提升英语应试水平。'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/王素丽.png',
            isFirst: false
          },
          {
            name: '方慧岩',
            zj: '考研英语',
            des: [
              '从事考研英语教学多年，曾参与编写高等教育出版社出版的《考研英语大纲配套强化指导》、《考研英语阅读理解及翻译》及《考研英语历年真题解析》等考研书籍。',
              '深刻了解考研英语命题思路、重难点及考点变化趋势，别具一格的授课风格，自身对于英语考试的应考策略和考试心态调整有着独到的见解。对于考研英语的应试有独特的方法和技巧。'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/方慧岩.png',
            isFirst: false
          },
          {
            name: '代志运',
            zj: '考研英语',
            des: [
              '留英硕士，8年考研英语辅导经验，深受广大考生爱戴。',
              '讲课过程中将知识和技巧讲的透彻深刻，有自己独特的教学方法，情景再现式讲授考研英语试题中出现的各种文化历史现象，',
              '教学细腻，指导精准，紧扣核心，切中考点'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/代志运.png',
            isFirst: false
          }
        ],
        [
          {
            name: '王天石',
            zj: '考研英语',
            des: [
              '北京师范大学硕士，剑桥商务英语高级，十年考研英语授课经验；',
              '著名实力派考研英语辅导专家。长期从事考研英语辅导工作，熟知考研出题特点。',
              '授课风趣幽默，课堂气氛活跃，深入浅出，化繁为简，独创的阅读技巧帮助学生了解出题意图，快速找到解题思路，让学生真正的了解考试，深得学生喜爱。'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/王天石.png',
            isFirst: true
          },
          {
            name: '王素丽',
            zj: '考研英语',
            des: [
              '西安外国语大学硕士，十余年考研英语辅导经验。资深考研英语辅导老师，多年考研英语教学经验。',
              '专业扎实，治学严谨，授课幽默风趣；对考研英语命题特点及答题方法技巧的研究深入透彻， 尤其擅长耐心高效地帮助基础较差的学生迅速提升英语应试水平。'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/王素丽.png',
            isFirst: false
          },
          {
            name: '付雅',
            zj: '考研英语',
            des: [
              '十余年考研英语授课经验，在教学过程中贯彻的“一切从学生角度出发”的教学理念，开创了阅读“严谨教学”的新境界。',
              '从宏观到微观，逐层深入考研真题的每一个细节，在教授课程中能针对不同时期考生的状况给予辅导，快速提升学生英语得分能力。'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/付雅.png',
            isFirst: false
          },
          {
            name: '任仁',
            zj: '考研英语',
            des: [
              '国内知名高校英语口译硕士毕业。教龄7年，深入教学一线，教学经验丰富。',
              '考研英语全模块讲解，对长难句、阅读等核心模块有独到的讲解思路，让学生在激情的课堂中学有所得。独特的教学方法，让更多基础差的学生树立信心，不断提高英语水平。',
              '善于分层教学，授课逻辑性强，富有激情，讲解清晰易懂。'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/任仁.png',
            isFirst: false
          }
        ],
        [
          {
            name: '曹海峰',
            zj: '考研数学',
            des: [
              '北京科技大学硕士 ，考研数学辅导专家，多年一线讲师，重要骨干教师，数学授课经验丰富。',
              '授课思路清晰，逻辑性强，能够把考研数学题目进行"稳准狠"解析，让学生短时间内掌握重要考点，学有所获。'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/曹海峰.png',
            isFirst: true
          },
          {
            name: '张云静',
            zj: '考研数学',
            des: [
              '中课考研独家签约讲师，知名双一流高校工学硕士。',
              '耐心细致，讲课通俗易懂，具体形象，层次分明，直击学生痛点，使考生能够举一反三，融会贯通。',
              '善于分析，捕捉核心考点，重点突出，让学员轻松得高分'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/张云静.png',
            isFirst: false
          }
        ],
        [
          {
            name: '莫修明',
            zj: '管综（数学）',
            des: [
              '副教授，专业功底深厚，教学能力强，第八届北京高校青年教师教学比赛中囊括所有奖项，讲课逻辑性强，思路清晰，重点突出，方法灵活有效，授课轻松幽默，极具感染力。',
              '莫老师深耕管理类联考十五年，深谙命题规律，帮助众多学子成功圆梦，深受历界学员欢迎。被誉为联考数学通。',
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/莫修明.png',
            isFirst: true
          },
          {
            name: '刘玉芳',
            zj: '管综（逻辑）',
            des: [
              '考研辅导代表人物，专硕逻辑、写作辅导讲师。多年从事考研辅导，讲解细致，认真负责，层次分明，循序渐进，擅长结合课堂练习帮助学员把所学知识点快速掌握。授课风格渊博大气，语言生动幽默，激情洋溢的课堂展示富有亲和力，深受广大考生的欢迎。',
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/刘玉芳.png',
            isFirst: false
          },
          {
            name: '胡昊',
            zj: '管综（写作）',
            des: [
              '管理类联考硕士考研写作实力派名师。多年从事考研命题研究及授课工作。擅长考研备考规划、择校择专业的操作方法，管综逻辑的秒分技巧、高分写作等一系列课程，学生评分极高，多次获得好评榜首，有效快速提升学生应试能力。',
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/胡昊.png',
            isFirst: false
          },
          {
            name: '杨洁',
            zj: '管理类联考数学',
            des: [
              '中课考研教学团队核心成员，致力于专业硕士联考数学的研究及教学。',
              '中课考研数学科目领头人，激情的教学风格深受学员喜爱，浅显易懂地让学生领悟知识点及重难点。擅长带领学生归纳、总结，有自己一整套科学的数学教学体系',
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/杨洁.png',
            isFirst: false
          },
          {
            name: '王苁宇',
            zj: '管理类联考数学',
            des: [
              '中课考研数学工作室核心成员，新生代管理类联考数学辅导教师。',
              '授课风格严谨，思路清晰，对学生存在的疑惑讲解耐心细致，尽职尽责，是广大学子的良师益友。',
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/王苁宇.png',
            isFirst: false
          }
        ],
        [
          {
            name: '卓清',
            zj: '考研教育学',
            des: [
              '教育硕士，从事教育类考研课程讲授6年，专业辅导311和333系统课程。讲授风格深入浅出，以点带面。以独特的思路串讲+关键词的方式，配合生动的案例讲解，帮助学生记忆理解，深受学生好评。'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/卓清.png',
            isFirst: true
          }
        ],
        [
          {
            name: '杨净',
            zj: '考研护理学',
            des: [
              '北京 985 学校医学部教学医院主治医师；',
              '原西医综合大纲解析主编，人卫出版社医学类考研辅导用书主编',
              '12 年考研教学经验，辅导 10 万+学员；',
              '著有畅销复习用书《西医综合速记突破 210 分》，累计销量 16 万册；'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/杨净.png',
            isFirst: true
          },
          {
            name: '夏桂新',
            zj: '考研护理学',
            des: [
              '中国协和医科大学（清华大学医学部）研究生',
              '医师、护士考试辅导名师，有丰富的培训经验，深谙考试命题规律，深受广大考生欢迎。',
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/夏桂新.png',
            isFirst: false
          },
          {
            name: '宋瑞霞',
            zj: '考研护理学',
            des: [
              '知名 985 高校护理学老师',
              '具有独特的学习指导方法',
              '教学严谨、重点突出，授课富有激情，深受学员喜爱。'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/宋瑞霞.png',
            isFirst: false
          },
          {
            name: '崔菲菲',
            zj: '考研护理学',
            des: [
              '知名 985 高校护理学老师',
              '授课思路清晰、通俗易懂、风趣幽默',
              '教学中擅于运用多种方法让考生记住重点、难点',
              '其编写的《护考易混易错点》深受广大学员喜爱。'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/崔菲菲.png',
            isFirst: false
          }
        ],
         [
          {
            name: '杨净',
            zj: '考研临床医学',
            des: [
              '北京 985 学校医学部教学医院主治医师；',
              '原西医综合大纲解析主编，人卫出版社医学类考研辅导用书主编；',
              '12 年考研教学经验，辅导 10 万+学员；',
              '著有畅销复习用书《西医综合速记突破 210 分》，累计销量 16 万册；'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/杨净.png',
            isFirst: true
          },
          {
            name: '唐子益',
            zj: '考研临床医学',
            des: [
              '长期从事北医临床带教，多年的临床教学经验。',
              '独家总结出适合众多考研医学学子的临床教学法，即“临床思维主线学习法”，对近20年真题进行潜心研究，与临床思维主线深度结合，使用独立高效的记忆法。',
              '编著考研12730计划丛书《临床医学记忆口袋书》《临床医学真题知识点分类解析》等多本书籍，拥有“行走的内科书、行走的教科书、临床内科记忆大师”等称号。'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/唐子益.png',
            isFirst: false
          },
          {
            name: '李雪松',
            zj: '考研临床医学',
            des: [
              '知名医学院校老师，长期从事生物化学教学工作',
              '中课医学团队教研组主要成员，对生物化学颇有研究',
              '善于医学知识与生活相联系，善于从学生的角度发现问题，解决问题',
              '授课形式丰富多彩，深入浅出，颇受学生喜欢'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/李雪松.png',
            isFirst: false
          },
        ],
        [
          {
            name: '艾佳',
            zj: '考研心理学',
            des: [
              '北京师范大学应用心理学硕士',
              '心理学金牌讲师，五百强企业高级内训师。',
              '授课风格深入简出，轻松风趣，深受学员喜爱。',
              '主讲：普通心理学、社会心理学、人格心理学'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/艾佳.jpg',
            isFirst: true
          },
          {
            name: '博文',
            zj: '考研心理学',
            des: [
              '吉林大学应用心理学硕士',
              '资深考研讲师，长期从事心理学考研培训，全面熟知心理学考研全领域课程，深谙复习之道，尤以心理学导论、实验心理学、心理统计与测量等科目为擅长',
              '授课深入浅出，逻辑体系清晰，可有效帮助学员大大提高复习效率。',
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/博文.png',
            isFirst: false
          },
          {
            name: '李佳',
            zj: '考研心理学',
            des: [
              '国家知名高校心理健康教育专业本硕，国家三级心理咨询师，家庭教育指导师。',
              '授课风格耐心细致，化繁为简，深受学员喜爱。',
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/李佳.png',
            isFirst: false
          },
          {
            name: '木言',
            zj: '考研心理学',
            des: [
              '第四军医大学应用心理学硕士',
              '授课风格平易近人',
              '用通俗的语言讲解抽象的心理学概念'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/课宝.png',
            isFirst: false
          },
        ],
        [
          {
            name: '杨艳霞',
            zj: '考研法硕',
            des: [
              '中课考研刑法授课名师，中国政法大学刑法学博士，浙江工业大学法学院副教授',
              '博学多才，授课简洁、清晰，技巧性强，课堂氛围好，擅长根据应试特点针对性讲课。',
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/杨艳霞.png',
            isFirst: true
          },
          {
            name: '韩祥波',
            zj: '考研法硕',
            des: [
              '中国政法大学民商法学博士。',
              '授课逻辑严谨、深入浅出、通俗易懂、风趣幽默，极富有感染力；',
              '通过生活化的民法案例，授课引人入胜。紧扣法硕命题脉搏，讲解全面到位透彻，对备战法硕具有极强的针对性，深受考生爱戴！被学生们爱称“波波老师”。'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/韩祥波.png',
            isFirst: false
          },
          {
            name: '陈璐琼',
            zj: '考研法硕',
            des: [
              '毕业于北京大学理论法学专业，从事法硕考研辅导培训15年。',
              '幽默风趣、充满激情的授课方式深受广大考生喜爱。近三年连续命中法理学简答题、论述题和法制史的分析题等，被考生称为“陈录取”。跟璐璐，就录取，成为广大考生的口头禅。',
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/陈璐琼.png',
            isFirst: false
          },
          {
            name: '尹楠',
            zj: '考研法硕',
            des: [
              '尹楠，实力派讲师，多年教学经验，深谙命题规律。',
              '授课思路清晰、以点带面，高度提炼串联，直击考点，擅长私塾化教学。',
              '多年教学积累，有一套法硕教学辅导独门秘籍，授课严谨认真，深受学员好评。'
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/尹楠.png',
            isFirst: false
          },
          {
            name: '叶晓川',
            zj: '考研法硕',
            des: [
              '中国政法大学法学博士。有超过15年法硕、法考培训辅导经验。',
              '授课重点突出，激情澎湃，贴近实战，被学员赞誉为“用生命在讲课”，深受学员好评。',
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/叶晓川.png',
            isFirst: false
          },
          {
            name: '空玄清',
            zj: '考研法硕',
            des: [
              '民法知识产权主讲人，法考法硕双栖讲师。',
              '擅长框架知识体系建立，精确把握知识点，并拥有丰富的教学经验，深受学员口碑好评，多次前往台湾进行民法学术交流，为教学提供深厚理论保障。',
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/空玄清.png',
            isFirst: false
          },
          {
            name: '张宸',
            zj: '考研法硕',
            des: [
              '中央民族大学法学博士，多年从事法硕相关教学工作。',
              '擅长把握并解读法硕命题规律，授课体系性强，重点明确，直击考点，可以帮助考生更为准确地把握考试重点。应试过关为体，励志规划为髓。',
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/张宸.png',
            isFirst: false
          },
          {
            name: '乔国锋',
            zj: '考研法硕',
            des: [
              '中国人民大学法学硕士，首批涉外律师法律硕士。',
              '五年执业律师经历，多年法硕辅导培训经验，对考试分析的考察重点、命题方式、命题陷阱十分熟悉。',
            ],
            cover: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/乔国锋.png',
            isFirst: false
          }
        ],

      ],
      courseIndex: 0,
      courseList: [
        {
          id: '0',
          className: '专业课基础班',
          list: [
                {
                  isChecked: false,
                  courseName: '教育综合',
                  money: 1250
                },
                {
                  isChecked: false,
                  courseName: '应用心理',
                  money: 1250
                },
                {
                  isChecked: false,
                  courseName: '护理综合',
                  money: 1250
                },
                {
                  isChecked: false,
                  courseName: '西医综合',
                  money: 1250
                },
                {
                  isChecked: false,
                  courseName: '法律（法学）',
                  money: 1250
                },
                 {
                  isChecked: false,
                  courseName: '法律（非法学)',
                  money: 1250
                },
                 {
                  isChecked: false,
                  isOnLineService:true,
                  courseName: '文学业务课一',
                  teachers: ['在线咨询'],
                  period: '在线咨询',
                  money: '在线咨询'
                },
                {
                  isChecked: false,
                  isOnLineService:true,
                  courseName: '文学业务课二',
                  teachers: ['在线咨询'],
                  period: '在线咨询',
                  money: '在线咨询'
                },

           ],

          information: ['智能题库', '模考系统', '智能课件/讲义下载'],

          service: [
            '班主任服务',
          ],
          classContent: [
            { title: '录播课程', children: ['基础阶段：高分导学课（26）','基础阶段：基础精讲课（26）','强化阶段：圆梦强化课（26）','冲刺阶段：冲刺点题课（26）'] },
            { title: '电子版配套资料', children: ['课程配套讲义（电子版）', '英语：核心1250词-速记表', '政治：思维导图；全年时政', '管综：核心公式-速查表','数学：核心公式-速查表'] }
          ]
        },
        {
          id: '1',
          className: '基础畅学班',
          list: [
                {
                  isChecked: false,
                  courseName: '英语一',
                  money: 1250
                },
                {
                  isChecked: false,
                  courseName: '英语二',
                  money: 1250
                },
                {
                  isChecked: false,
                  courseName: '管理类综合能力',
                  money: 1250
                },

                {
                  isChecked: false,
                  courseName: '政治',
                  money: 1250
                },
                {
                  isChecked: false,
                  courseName: '数学一',
                  money: 1250
                },
                 {
                  isChecked: false,
                  courseName: '数学二',
                  money: 1250
                },
                 {
                  isChecked: false,
                  courseName: '数学三',
                  money: 1250
                },

           ],

          information: ['智能题库', '模考系统', '智能课件/讲义下载'],
          service: [
            '班主任服务',
          ],
          classContent: [
            { title: '录播课程', children: ['基础阶段：高分导学课（26）','基础阶段：基础精讲课（26）','强化阶段：圆梦强化课（26）','冲刺阶段：冲刺点题课（26）'] },
            { title: '电子版配套资料', children: ['课程配套讲义（电子版）', '英语：核心1250词-速记表', '政治：思维导图；全年时政', '管综：核心公式-速查表','数学：核心公式-速查表'] }
          ]
        },
        {
          id: '2',
          className: '直播领学班',
          list: [
                {
                  isChecked: false,
                  courseName: '英语一',
                  money: 1980
                },
                {
                  isChecked: false,
                  courseName: '英语二',
                  money: 1980
                },
                  {
                  isChecked: false,
                  courseName: '政治',
                  money: 1980
                },
                {
                  isChecked: false,
                  courseName: '管理类综合能力',
                  money: 1980
                },


                {
                  isChecked: false,
                  courseName: '数学一',
                  money: 1980
                },
                 {
                  isChecked: false,
                  courseName: '数学二',
                  money: 1980
                },
                 {
                  isChecked: false,
                  courseName: '数学三',
                  money: 1980
                },

           ],
          information: ['智能题库', '模考系统', '智能课件/讲义下载', '享受连续的第二年网课重读服务'],
          service: [
           '班主任服务'
          ],
          classContent: [
            { title: '直播课程', children: ['基础夯实课（26）', '高分进阶课（26）', '救命大串讲（26）', '实战三套卷（26）'] },
            { title: '电子版配套资料', children: ['课程配套讲义（电子版）', '科目真题（电子版）', '英语：核心1250词-速记表', '政治：思维导图；全年时政','管综：核心公式-速查表','数学：核心公式-速查表'] },
            { title: '纸质版配套资料', children: ['各科目《基础一本通》', '各科目《强化一本通》', '各科目《真题一点通》'] }
          ]
        },
        {
          id: '3',
          className: '优学班',
          list: [
                {
                  isChecked: false,
                  courseName: '英语一',
                  money: 2580
                },
                {
                  isChecked: false,
                  courseName: '英语二',
                  money: 2580
                },
                  {
                  isChecked: false,
                  courseName: '政治',
                  money: 2580
                },
                {
                  isChecked: false,
                  courseName: '管理类综合能力',
                  money: 2580
                },


                {
                  isChecked: false,
                  courseName: '数学一',
                  money: 2580
                },
                 {
                  isChecked: false,
                  courseName: '数学二',
                  money: 2580
                },
                 {
                  isChecked: false,
                  courseName: '数学三',
                  money: 2580
                },

           ],
          information: ['智能题库', '模考系统', '智能课件/讲义下载', '享受连续的第二年网课重读服务'],
          service: [
            '班主任服务',
            '学管师基础服务',
          ],
          classContent: [
            { title: '录播课程', children: ['基础阶段：高分导学课（26）', '基础阶段：基础精讲课（26）', '强化阶段：圆梦强化课（26）', '强化阶段：夺分技巧课（26）','强化阶段：真题解析课（26）','冲刺阶段：冲刺点题课（26）'] },
            { title: '直播课程', children: ['基础夯实课（26）', '高分进阶课（26）', '救命大串讲（26）', '实战三套卷（26）'] },
            { title: '电子版配套资料', children: ['课程配套讲义（电子版）', '科目真题（电子版）', '英语：核心1250词-速记表', '政治：思维导图；全年时政','管综：核心公式-速查表','数学：核心公式-速查表'] },
            { title: '纸质版配套资料', children: ['各科目《基础一本通》', '各科目《强化一本通》', '各科目《真题一点通》'] }
          ]
        },

      ]
    }
  },
  watch: {
    courseIndex() {

      $('.kcnr .children').show(200)
      $('.kcnr .title-des img').attr('src', 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/minus_icon.png')
    }
  },
  computed: {
    totalMoney() {
      let totalMoney = 0
      if (this.moneyLabels) {
        this.moneyLabels.split('+').forEach(item => {
          totalMoney += parseInt(item)
        })
      }
      return totalMoney
    },
    moneyLabels() {
      let moneyArr = []
      this.courseList.forEach((item, index) => {
        item.list.forEach((subItem, subIndex) => {
            if (index == this.courseIndex  && subItem.isChecked) {
              moneyArr.push(subItem.money)
            }
        })
      })
      return moneyArr.join('+')
    }
  },
  methods: {
    //在线客服
    serviceClick() {
      Promise.all([
        loadScript('js', 'https://scripts.easyliao.com/js/easyliao.js', 'body'),
        loadScript('js', 'https://scripts.easyliao.com/34383/84293/lazy.js', 'body')
      ]).then(res => {
        window.open(
          'https://live.easyliao.com/live/chat.do?c=34383&g=48911&config=84293',
          '_blank',
          'height=600,width=800,top=50,left=200,status=yes,toolbar=no,menubar=no,resizable=no,scrollbars=no,location=no,titlebar=no'
        )
      })
    },
    itemClick(item) {
      item.isChecked = !item.isChecked
    },
    teamNavClick(index) {
      this.teamIndex = index
      this.currentIndexTeacher = 0
      this.teacherList.forEach(item => {
        item.forEach((sub, index) => {
          sub.isFirst = index == 0
        })
      })
    },
    changeClick(currentIndex, other) {
      this.teacherList[this.teamIndex].forEach(item => (item.isFirst = false))
      other.isFirst = true
      this.currentIndexTeacher = currentIndex
      this.teacherList[this.teamIndex][currentIndex] = other
    }
  },
  mounted() {

    $('body').on('click', '.kcnr .title-des', function () {
      if ($(this).children('img').attr('src').indexOf('plus_icon.png') != -1) {
        $(this).children('img').attr('src', 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/minus_icon.png')
        $(this).siblings('.children').show(200)
      } else {
        $(this).children('img').attr('src', 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/plus_icon.png')
        $(this).siblings('.children').hide(200)
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.class-intro-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 60px;
  box-sizing: border-box;
  background: #f0f7ff;

  & > img {
    width: 408px;
    height: 94px;
  }
  .intro-content {
    display: flex;
    flex-direction: column;
    margin-top: 45px;
    .sticky-box {
      position: sticky;
      top: 96px;
      z-index: 9;
    }
    .title-content {
      display: flex;
      align-items: center;
      overflow: hidden;
      height: 80px;
      border-radius: 30px 30px 0 0;
      background: #2a3a6c;
      .title-box {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        color: #fff;
        font-size: 32px;
        cursor: pointer;
        &.on {
          background: linear-gradient(90deg, #3cb4ff 0%, #3867f1 100%);
        }
      }
    }
    .category {
      padding: 32px 0;
      background: #fff;
      ul {
        display: flex;
        margin-left: 50px;
        li {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 38px;
          margin-right: 20px;
          border: 1px solid #f86958;
          color: #f86958;
          font-size: 18px;
          padding: 0 12px;
          cursor: pointer;
          &.on {
            color: #fff;
            background: #f86958;
          }
        }
      }
    }

    .label-box {
      display: flex;
      align-items: center;
      padding: 28px 59px;
      border-top: 1px solid #d5e3ff;
      border-bottom: 1px solid #d5e3ff;
      background: #fff;
      span {
        color: #333333;
        font-size: 20px;
        font-weight: bold;
      }
    }

    .detail-container {
      display: flex;
      background: #fff;
      padding: 0px 0px 10px 40px;
      .left-box {
        border-right: 1px dashed #eeeeee;
        width: 415px;
        .content-box {
          display: flex;
          align-items: center;
          padding: 30px 0;
          border-bottom: 1px dashed #eeeeee;
          &:last-child {
            border-bottom: none;
          }
          cursor: pointer;
          .course-name {
            display: flex;
            align-items: center;
            width: 260px;
            color: #333333;
            font-size: 16px;
            img {
              margin-right: 10px;
            }
          }
          .teacher-des {
            display: flex;
            flex-direction: column;
            width: 165px;
            span {
              display: flex;
              align-items: center;
              margin-bottom: 10px;
              color: #333333;
              font-size: 16px;
              img {
                margin-right: 8px;
              }
            }
          }
          .period-box {
            color: #333333;
            font-size: 16px;
            width: 98px;
          }
          .money-box {
            color: #ed5f54;
            font-size: 24px;
          }
        }
      }
      .right-box {
        display: flex;
        .course-box {
          width: 280px;
          padding-top: 24px;
          margin-left: 95px;
          .course-top {
            cursor: pointer;
          }
          .kcnr {
            .title-des {
              display: flex;
              align-items: center;
              color: #333333;
              font-size: 16px;
              margin-bottom: 10px;
              cursor: pointer;
              img {
                margin-right: 10px;
              }
            }
            .children {
              position: relative;
              color: #666;
              font-size: 16px;
              margin-bottom: 12px;
              margin-left: 15px;
              padding-left: 12px;
              &:last-child {
                margin-bottom: 10px;
              }
              &:before {
                content: '';
                position: absolute;
                left: 0;
                top: 10px;
                width: 5px;
                height: 5px;
                background: #4c7af2;
              }
            }
          }
        }
        .class-service-box {
          padding-top: 42px;
          margin-left: 80px;
          & > span {
            display: block;
            color: #333333;
            font-size: 16px;
            padding-left: 29px;
            padding-bottom: 10px;
          }
          ul {
            li {
              display: flex;
              align-items: center;
              margin-bottom: 8px;
              img {
                width: 21px;
                height: 17px;
                margin-right: 7px;
              }
            }
          }
        }
      }
    }
    .buy-box {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 146px;
      background: #fffbf0;
      padding-right: 30px;
      p {
        display: flex;
        align-items: center;
        font-size: 22px;
        color: #333333;
        span {
          font-size: 32px;
          color: #ed5f54;
        }
        .buy {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 202px;
          height: 66px;
          margin-left: 38px;
          background: linear-gradient(243deg, #ff883c 0%, #f0383c 100%);
          box-shadow: 0px 3px 6px 1px rgba(245, 86, 60, 0.28);
          border-radius: 33px;
          color: #fff;
          font-size: 20px;
          cursor: pointer;
        }
      }
    }
  }
}
.teacher-box {
  height: 787px;
  padding-top: 60px;
  box-sizing: border-box;
  overflow: hidden;
  background: url(https://zk-web-source.oss-cn-beijing.aliyuncs.com/publicity1/teacher_bg.png) 100% 100% no-repeat;
  .t-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    & > img {
      width: 296px;
      height: 95px;
    }
    .nav {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-top: 40px;
      padding-left: 120px;
      padding-right: 120px;

      li {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100px;
        height: 50px;
        border-radius: 25px 25px 25px 25px;
        background: #fff;
        color: #2d67e3;
        cursor: pointer;
        &.on {
          color: #fff;
          background: linear-gradient(236deg, #3cb4ff 0%, #3867f1 100%);
        }
      }
    }
    .content {
      display: flex;
      align-items: center;
      width: 1200px;
      height: 430px;
      margin-top: 40px;
      background: #ffffff;
      border-radius: 20px;
      .cover {
        width: 305px;
        height: 390px;
        margin-left: 20px;
        margin-right: 47px;
        border-radius: 10px;
        object-fit: cover;
        flex-shrink: 0;
      }
      .r-info {
        display: flex;
        flex-direction: column;
        h3 {
          font-size: 22px;
          color: #333333;
          margin-bottom: 15px;
        }
        span {
          color: #333333;
          font-size: 18px;
        }
        ul {
          margin-top: 26px;
          li {
            margin-bottom: 10px;
            padding-right: 10px;
          }
        }
        .more-cover {
          display: flex;
          cursor: pointer;
          margin-top: 30px;
          img {
            width: 60px;
            height: 60px;
            margin-right: 30px;
            border-radius: 50%;
            border: 2px solid #2d67e3;
            object-fit: cover;
            transition: all 0.5s;
            &.on {
              transform: scale(1.1);
            }
          }
        }
      }
    }
  }
}

.service-box {
  height: 725px;
  padding-top: 60px;
  box-sizing: border-box;
  background: #fff;
  .title-img-box {
    width: 100%;
    text-align: center;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 60px;
    li {
      width: 540px;
      height: 215px;
      margin-bottom: 20px;
      margin-right: 15px;
      &:nth-child(2n) {
        margin-right: 0;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.bottom-bg {
  width: 100%;
  vertical-align: bottom;
}
</style>
